import { z } from 'zod'
import type { LowerHex } from '../../types'
import type { InternalTransactionWithIndex } from '../../types/internalTransaction'
import type { KaiascanTransactionInfo } from './getTransactionInfo'
import type { KaiascanOapiClient } from './oapiClient'
import { kaiascanOapiInternalTransactionSchema } from './schema'

type GetInternalTransactionsByTransactionHashParameters = {
  client: KaiascanOapiClient
  txhash: LowerHex
  transactionInfo: KaiascanTransactionInfo
  headers?: Record<string, string>
}

const resultSchema = z.object({
  results: z.array(kaiascanOapiInternalTransactionSchema),
})

/**
 * Kaiascan OAPI から transaction hash の internal transaction を取得する。
 *
 * @param parameters - OAPI client、transaction hash、補完用 transaction info、headers。
 * @returns internal transaction の配列。
 */
export const getInternalTransactionsByTransactionHash = async ({
  client,
  txhash,
  transactionInfo,
  headers,
}: GetInternalTransactionsByTransactionHashParameters): Promise<
  InternalTransactionWithIndex[]
> => {
  const result = await client.get({
    path: `/api/v1/transactions/${txhash}/internal-transactions`,
    query: {},
    resultSchema,
    headers,
  })
  return result.results
    .filter((transaction) => transaction.level !== 1)
    .map((transaction) => ({
      blockNumber: transactionInfo.blockNumber,
      contractAddress: undefined,
      from: transaction.from?.address,
      gas: transaction.gas_limit ?? 0n,
      isError: transaction.error || transaction.reverted,
      timestamp: transactionInfo.timestamp,
      to: transaction.to?.address,
      txHash: txhash,
      value: transaction.amount ?? 0n,
    }))
}
